import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Snackbar } from "../../components/snackbar/Snackbar.js";
import { SnackbarIconUpdate } from "../../components/snackbar/SnackbarIcon.js";
import { getRealtimeActions } from "./actions.js";
import { realtimeSelector } from "./selectors.js";
const localizedRealtimeNotification = defineMessages({
  realtimeNotificationTitle: {
    id: "realtimeNotificationTitle",
    defaultMessage: "Updated modules"
  },
  realtimeNotificationButton: {
    id: "realtimeNotificationButton",
    defaultMessage: "Update"
  },
  realtimeNotificationMessage: {
    id: "realtimeNotificationMessage",
    defaultMessage: "{updatedTitles} have been updated. Please refresh to see the update info."
  }
});
function RealtimeNotification() {
  const dispatch = useDispatch();
  const realtimeState = useSelector(realtimeSelector);
  const { formatMessage } = useIntl();
  const updatedViews = realtimeState?.updates ? Object.keys(realtimeState.updates) : [];
  const updatedTitles = updatedViews?.join(", ");
  const realtimeActions = getRealtimeActions();
  const reload = () => {
    dispatch(realtimeActions.updateViews());
  };
  const close = () => {
    dispatch(realtimeActions.cleanUpdatedViews());
  };
  return /* @__PURE__ */ React.createElement(
    Snackbar,
    {
      open: updatedTitles?.length > 0,
      message: formatMessage(localizedRealtimeNotification.realtimeNotificationMessage, { updatedTitles }),
      messageIcon: /* @__PURE__ */ React.createElement(SnackbarIconUpdate, null),
      onAction: reload,
      action: formatMessage(localizedRealtimeNotification.realtimeNotificationButton),
      onClose: close
    }
  );
}
export {
  RealtimeNotification
};
//# sourceMappingURL=RealtimeNotification.js.map
